import type { ReactNode } from 'react';
import s from './AppShell.module.css';

export interface AppShellProps {
  /** `<Rail />`. */
  rail: ReactNode;
  /** `<Topbar />`. */
  topbar: ReactNode;
  children: ReactNode;
}

/** Moldura do console (`.app` + `.main` + `.page`): rail à esquerda, topbar e conteúdo. */
export function AppShell({ rail, topbar, children }: AppShellProps) {
  return (
    <div className={s.app}>
      {rail}
      <div className={s.main}>
        {topbar}
        <main className={s.page}>{children}</main>
      </div>
    </div>
  );
}
